import { splitWordsOnUpperCase } from "@repo/helpers";
import { DateTimePicker, DropDownList, Selector, TextBox, ToggleSlider } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";

import AuditApi from "../../api/auditApi";
import { LocalProps } from "./types";

function ParamEditor(props: LocalProps) {
	const { Name, DefaultValue } = props.paramDefinition;
	const label = props.paramDefinition.label ?? splitWordsOnUpperCase(Name);
	const source = props.paramDefinition.Source ?? "";
	const ddlSourceQuery = useQuery({
		queryKey: ["ddlSource", source],
		queryFn: async () => source && (await AuditApi.loadSource(source)),
	});

	function valueUpdated(value: any) {
		props.updateValue(value, props.paramDefinition.Name, ddlSourceQuery.isFetched);
	}

	switch (props.paramDefinition.Type) {
		case "Text":
			return renderText();
		case "Int":
			return renderNum();
		case "Bool":
			return renderSwitch();
		case "Radio":
			return renderRadio();
		case "DropDown":
			return renderDropdown();
		case "DropDownMulti":
			return renderDropdown(true);
		case "DateTime":
			return renderDateTimePicker();
	}
	return <div></div>;

	function renderText() {
		return <TextBox {...props} changeHandler={valueUpdated} label={label} id={Name} placeholder={DefaultValue} />;
	}

	function renderSwitch() {
		return <ToggleSlider {...props} changeHandler={valueUpdated} label={label} id={Name} />;
	}

	function renderNum() {
		return (
			<TextBox
				{...props}
				changeHandler={valueUpdated}
				label={label}
				id={Name}
				type="number"
				placeholder={DefaultValue}
			/>
		);
	}

	function renderRadio() {
		const values = ddlSourceQuery.data || [];
		return (
			<Selector
				{...props}
				changeHandler={valueUpdated}
				values={values}
				loaded={values.length > 0}
				label={label}
				id={Name}
				valueProp="id"
				textProp="value"
				clearable
				renderAsPanels={false}
			/>
		);
	}

	function renderDropdown(multi?: boolean) {
		const values = ddlSourceQuery.data || [];

		return (
			<DropDownList
				{...props}
				changeHandler={valueUpdated}
				id={Name}
				label={label}
				isMulti={multi}
				values={values}
				loaded={values.length > 0}
				valueProp="id"
				textProp="value"
				clearable
			/>
		);
	}

	function renderDateTimePicker() {
		return <DateTimePicker {...props} id={Name} name={Name} label={label} changeHandler={valueUpdated} dateOnly />;
	}
}

export default ParamEditor;
